import { useMemo } from 'react'
import { Alert } from 'antd'
import { NOT_SHIPPED_KEY } from '@Orders/constants'

import Box from '~/core/Box'
import SalesOrderSteps from '../OrderDetailHeaderAndFooter/SalesOrderSteps/SalesOrderSteps'
import { salesOrder_salesOrder_shipments_items as ShipmentsItemsType } from '../Queries/__generated__/salesOrder'

import OrderedItemsDataTable from './OrderedItems/components/OrderedItemsDataTable'
import Shipment from './Shipment'
import { OrderListType } from './types'
import { getShipmentCount } from './logic'

export default function OrderList(props: OrderListType) {
    const {
        deliveryStatus,
        fictivEstimatedDeliveryDate,
        isImOrder,
        isImShipmentsEnabled,
        isImReorder,
        orderId,
        orderedItemsOnClickPrevious,
        orderedItemsOnClickNext,
        orderedItemsCursor,
        orderedItemsPageNumber,
        orderName,
        quoteType,
        salesOrderLinesTotal,
        salesOrderLines,
        setSelectedTab,
        setSelectedShipmentId,
        shipmentTotal,
        shipments,
        shippedBy,
        shipmentIdsMap,
    } = props

    const isPlatformOrder = quoteType !== null
    const shipmentLinesContent = useMemo(() => {
        return shipments.map((shipment: ShipmentsItemsType) => {
            return (
                <Shipment
                    id={shipment.id}
                    key={shipment.id}
                    shipmentCount={getShipmentCount(
                        shipment?.id,
                        shipmentIdsMap,
                    )}
                    shipmentTotal={shipmentTotal}
                    shipmentData={shipment}
                    isImOrder={isImOrder}
                    shipmentMethod={shipment.shippingMethod}
                />
            )
        })
    }, [shipments, shipmentIdsMap, shipmentTotal, isImOrder])

    return (
        <>
            {!isImOrder && isPlatformOrder && (
                <SalesOrderSteps
                    deliveryStatus={deliveryStatus}
                    shippedBy={shippedBy}
                    fictivEstimatedDeliveryDate={fictivEstimatedDeliveryDate}
                    shipments={shipments}
                    salesOrderLines={salesOrderLines}
                />
            )}
            {!isImShipmentsEnabled && (
                <>
                    {shipmentTotal > 0 && salesOrderLinesTotal && (
                        <Box marginBottom="12px">
                            <Alert
                                style={{ width: '100%' }}
                                message={
                                    <Box marginTop="2px">
                                        Your order contains multiple shipments.
                                    </Box>
                                }
                                type="info"
                                showIcon
                            />
                        </Box>
                    )}
                    {shipmentLinesContent}
                </>
            )}
            <OrderedItemsDataTable
                cursor={orderedItemsCursor}
                isImOrder={isImOrder}
                isImReorder={isImReorder}
                key={NOT_SHIPPED_KEY}
                orderId={orderId}
                orderName={orderName}
                onClickPrevious={orderedItemsOnClickPrevious}
                onClickNext={orderedItemsOnClickNext}
                pageNumber={orderedItemsPageNumber}
                setSelectedTab={setSelectedTab}
                setSelectedShipmentId={setSelectedShipmentId}
                shippedBy={shippedBy}
                shipments={shipments}
                shipmentIdsMap={shipmentIdsMap}
            />
        </>
    )
}
